import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;

  gap: 20px;

  border-radius: 4px;
  padding: 0px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  box-sizing: border-box;

  h1 {
    color: var(--secondary-color);
    width: 80vw;
    text-align: center;
  }

  h2 {
    width: 80vw;
    text-align: center;
  }

  span {
    font-size: 20px;
  }

  img {
    height: 30%;
    width: 30%;
    margin: 0 30px;
  }

  .HCloud {
    color: var(--secondary-color);
    font-size: 2rem;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    img {
      display: none;
    }
  }
`;
